import React, { useRef, useEffect } from 'react';

const VideoCard = ({ peer, label, isActive, onClick, onStream }) => {
  const ref = useRef();

  useEffect(() => {
    if (!peer) return;
    peer.on('stream', stream => {
      if (ref.current) {
        ref.current.srcObject = stream;
      }
      if (onStream) onStream(stream);
    });
  }, [peer]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      onClick={onClick}
      style={{
        width: 148, height: 96, minWidth: 148, borderRadius: 10, overflow: 'hidden',
        position: 'relative', cursor: 'pointer', flexShrink: 0,
        border: `2px solid ${isActive ? '#800020' : 'transparent'}`,
        background: '#0f172a', transition: 'border-color 0.2s, transform 0.15s',
      }}
    >
      <video
        ref={ref}
        autoPlay
        playsInline
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
      {label && (
        <div style={{
          position: 'absolute', bottom: 5, left: 6, right: 6,
          fontSize: 10.5, fontWeight: 600, color: 'white',
          background: 'rgba(6,13,26,0.75)', borderRadius: 5,
          padding: '2px 6px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap',
        }}>
          {label}
        </div>
      )}
    </div>
  );
};

export default VideoCard;
